/*
 * @Author: Merlin
 * @Date: 2023-12-01 18:13:41
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-13 16:20:40
 * @Description: 专门执行“加入” 某游戏时的一系统动作 
 */

import { useJoinStateStore } from '~/stores/cansino/joinState';
import { useUserStore } from '~/stores/user';
import { useGameHistoryStore } from '~/stores/cansino/gameHistory';
import { useLoadingStore } from '@/stores/loading';
import useSettingsStore from '~/stores/settings';
import { useAutoOptionStore } from '~/stores/cansino/autoOption';
// --- ↑ stores --------------------------------------------------------------
import { useGameSocket } from '~/socket/game';
import type { GameHistoryReponseStateType } from '~/socket/game/dto/index.dto';
import { useGameHistorySocket } from '~/socket/gamehistory';
import { useGameListSocket } from '@/socket/gamelist/index';
// --- ↑ socket --------------------------------------------------------------
import { iPaginationMax } from '@/components/Casino/History/Tabs/ts/Tabs';
import {
    getGameInfo,
    getGameLastRoundKey,
    aGamesShowResultWithDelay,
} from '@/common/js/gameAbout';

const isDev = import.meta.dev;
const {
    EMIT_GET_HISTORY, // 查询游戏历史信息（以往的开奖结果）
    ON_GAMES_INFO // 监听游戏hash更新
} = useGameHistorySocket();

const {
    EMIT_GETHISTORY_ON_JOIN, // 查询游戏下方表格的 all, high, rare
    ON_GAME_HISTORY_ON_HISTORY, // 开始逐条接收游戏历史数据，用于插入到 all, mybets
    EMIT_GAME_JOIN, // 进入游戏时獲取下注最大/最小金额
} = useGameSocket();

const {
    // ↓ 用于特殊游戏查询游戏配置(如抢红包）用于顶替 .join 接口，因为 .join 不可在此调用 
    EMIT_GET_GAME_CONFIG,
} = useGameListSocket();




// ↓ 用于记录“游戏历史数据” 的扑空事故 
export const oFailedShowDateInQ = {
    // 'plinkoGame': Date.now(), // 游戏名和失败时间 
};

// ↓ 用于取消订阅，不再接收某游戏的数据（稍后被赋值）
let stopReceivingGameHistoryObj = () => {};
// ↓ 用于取消订阅，不再接收某游戏的 jackpot, hash 
let stopReceivingJackpotHash = () => {};


// ================ 👆 一系列接口，常量变量，置于顶部 ================


/**
 * 👇查询“当前用户的”游戏历史信息，需要在join返回gameId后调用
 * @param gameId 游戏Id
 */
async function getHistoryAndSave(
    gameId: number,
    gameName: string,
    reconnect=false,
) {
    // ↓ 没登录不能查询 
    const oUser = await getUserInfo();
    if (!oUser.hasLogged) return;
    const oQueryInfo = {
        page: 1,
        category: 'dapps',
        game: String(gameId),
    };
    isDev && console.log('开始查◆当前用户下注记录：', gameName);
    EMIT_GET_HISTORY(oQueryInfo, (res) => {
        if (1 && isDev) {
            console.log(`结束查◆当前用户下注记录： ${gameName} \n`, deepCopy(res?.response || res));
        }
        if (!res?.response) return;
        const gameHistoryStore = useGameHistoryStore();
        const oStoreData = {
            historyData: res as any,
            gameName, // 记录游戏名称（重要）用于表示某某游戏的数据已经加载完毕
            gameId, // 新增项，用于表明当前历史所属的游戏 id
        };
        if (reconnect){
            oStoreData['gameOfRoute'] = gameName;
            const loadingStore = useLoadingStore();
            loadingStore.gameLoading = false; // 关闭 loading  
        }
        gameHistoryStore.setState(oStoreData);
    });
}


// ↓ 将逐条接收的游戏历史并保存起来，
// ↓ 数据将追加到 all, mybets 
const handleHistoryUpdate = (
    data: GameHistoryReponseStateType, // 下注结果
    sGameJoining, // 游戏名
) => {
    data.isMine = Number(data?.user?._id) === useUserStore().id;
    data.toDelay = ( // ← 添加“延时显示” 标记
        data.isMine && // ← 只对“当前用户”做延时显示
        aGamesShowResultWithDelay.includes(sGameJoining)
    );
    const iFailedTime = oFailedShowDateInQ[sGameJoining] || 0;
    const iMsAgo = Date.now() - iFailedTime; // 实测通常是几十毫秒，多数时候小于 100 
    const iRangeMS = 250; // ← 在这个时间范围内的”扑空“ 事故才被考虑（按需要调整，一般应小于 400ms 
    // ↓ 此游戏在刚刚显示历史数据失败了，那么此数据不必延时（容错手段） 
    if (iMsAgo <= iRangeMS && (sGameJoining != 'plinkoGame')){
        data.toDelay = false;
        oFailedShowDateInQ[sGameJoining] = 0; // 归零，防止二次生效  
        console.log(`🚺 扑空事件补丁：${sGameJoining} 游戏在 ${iMsAgo} ms 之前有“扑空” 事故，此数据不必延时显示`); 
    }
    if (sGameJoining === 'circleGame'){
        // 插入数据并在此 return，不可插入到 all 和 mybets  
        useJoinStateStore().setBetsOnline(data);
        return;
    }
    const all = useJoinStateStore().history.all;
    // ↓ 有可能是进行中且未结束的某局游戏，且这局游戏彻底结束后发来了更新后的数据，应覆盖，不要追加到数组
    const idx = all.findIndex((cur) => {
        // ↓ 此处采用双等号，以使字符与数值型的 id 判定为相同  
        const bResult = (cur._id == data._id);
        if (isDev && bResult) console.log('💟', deepCopy(cur), deepCopy(data)); 
        return bResult;
    });
    if (idx > -1) {
        isDev && console.log('all: 不插入，覆盖到：', idx);
        all[idx] = data as any;
    } else {
        all.unshift(data as any);
        all.splice(iPaginationMax, 1/0); // 防止超长
    }
    // ↑ 插入到 all
    // ↓ 插入到 mybets
    if (!data.isMine) return; // ← 防止插入其它人的数据
    const response = useGameHistoryStore().historyData.response;
    const [oFirst = {}] = response;
    if (data._id === oFirst._id) {
        response[0] = data; // 执行覆盖，不插入
    } else {
        response.unshift(data);
        response.splice(iPaginationMax, 1/0); // 防止超长
    }
};

// ↓ 保存游戏历史 all, rare, high
// 查询：遊戲歷史紀錄訂閱推送,拿取歷史相關列表紀錄
function saveGameHistoryOnJoin(data) {
    console.log('游戏下方大表格数据 (history on join) length:', Object.keys(data||{}));
    import.meta.env.DEV_MODE && console.log(deepCopy(data));
    if (!data || data.error) { 
        showNegativeNotify(data?.error);
        return;
    }
    const joinStateStore = useJoinStateStore();
    joinStateStore.$patch({
        history: {
            all: data.all,
            rare: data.rare,
            high: data.high,
            fun: data.all,
        },
    });
}

// ↓ 保存：游戏下注最大值等
function saveGameJoinState(
    oResponse,
    sGameJoining:string,
    reconnect=false,
) {
    const joinStateStore = useJoinStateStore();
    if (1) {
        // 这是高价值日志应在全环境打印 
        console.log(`开始保存游戏 ${sGameJoining}(${oResponse.gameId}) 的配置信息如下`);
        console.log(deepCopy(oResponse));
    }
    // ↓ EMIT_GAME_JOIN() 和 EMIT_GETHISTORY_ON_JOIN() 都有返回历史数据
    // ↓ 删除 EMIT_GAME_JOIN() 返回的历史，因为它有时候是空的
    // ↓ 删除以防止这个空数据覆盖了有效的数据
    Reflect.deleteProperty(oResponse, 'history');
    const oGameInfo = {
        // ↓ 赋值游戏名称（重要）用于表示某某游戏的数据已经加载完毕
        gameName: sGameJoining,
        gameId: oResponse.gameId,
    };
    const hash = (
        (
            !oResponse.hash
            && oResponse?.lastRound
            && Object.keys(oResponse?.lastRound)?.length
        )
        // tower、stairs等游戏初始没有返回hash，如果有上局未完成的游戏lastRound，则取lastRound中的hash
        ? oResponse?.lastRound?.hash
        : oResponse?.hash
    );
    if (reconnect){
        oGameInfo['gameOfRoute'] = sGameJoining;
    }
    joinStateStore.setState({
        ...oResponse,
        ...oGameInfo,
        jackpotDelay: deepCopy(oResponse.jackpot || 0), // delay 值用于界面显示 
        hash,
    });
    // 打印赔付的倍数信息 
    // if (1 && isDev){
    //     Sleep(500).then(()=>{
    //         const oConfig = joinStateStore.betttingLimits;
    //         const maxMulti = (oConfig.maxWin / oConfig.maxBets);
    //         if (!maxMulti){
    //             console.log('oConfig', deepCopy(oConfig)); 
    //         }
    //         console.log(`最大赔付倍数 ${oConfig.maxWin}/${oConfig.maxBets} =`, Number(maxMulti.toFixed(2)), '倍 🔶');
    //     });
    // }
}


// ↓ 修改 stores 的游戏信息，效用如下： 
// 1、彰显当前游戏信息未加载完成
// 2、强调当前并不位于某个游戏中（离开游戏页到其它位置时）
// 3、清空[sKey] 即清空当前旧的进行中的游戏数据，使用将来新值 
function toCleanStatus(sGameJoining) {
    const oJoinStateStore = useJoinStateStore();
    const sKey = getGameLastRoundKey(sGameJoining);
    oJoinStateStore[sKey] = null;
    oJoinStateStore.gameId = NaN;
    oJoinStateStore.gameName = '';
    oJoinStateStore.gameOfRoute = '';
    oJoinStateStore.gameRunning = false;
    // -----------------------------------------------------
    const gameHistoryStore = useGameHistoryStore();
    gameHistoryStore.gameName = '';
    gameHistoryStore.gameOfRoute = '';
    gameHistoryStore.gameId = NaN;
}


// ============ ▼ 以下是 “进入” 游戏的入口方法 ====================================
// ============ ▼ 这些入口方法将调用上方的一些方法  ====================================

interface EnterGameConfig {
    reconnect?: boolean, // 若为 true 表示 ws 已经重连，属于特殊类型的加入游戏  
    to?: object, // 路由跳转目标，备用，一些有 entrance 页面的游戏可能需要，如抢红包 
}

/**
 * @description: 进入游戏时调用多个接口，查询当前游戏的配置信息等
 *               有意设其为异步方法，防止造成阻塞  
 * @param {string} sGameJoining 游戏名称
 * @param {EnterGameConfig}
 * @return {void}
 */
export async function enterGame(
    sGameJoining: string,
    config: EnterGameConfig = {},
) {
    const {reconnect, to} = config;
    const oGameInfo = getGameInfo(
        to?.['path'] || useRoute().path,
    ); 
    const oAutoOptionStore = useAutoOptionStore();
    const joinStateStore = useJoinStateStore();
    const loadingStore = useLoadingStore();
    const sApi = oGameInfo.gameApi;
    loadingStore.gameLoading = true; // 显示 loading 
    oAutoOptionStore.renew(); // 进入新游戏时清空旧游戏的自动模式设定 
    // ↑ stores 相关声明和操作置于顶部  
    toCleanStatus(sGameJoining);
    // ↓ 下方的 stopReceiving*** 用于停止接收关于旧游戏的信息
    stopReceivingGameHistoryObj();
    stopReceivingJackpotHash(); 
    if (sGameJoining === 'futuresGame'){
        // ↓ 特殊游戏，不必执行下方各项查询，否则查不到还报错， 
        return;
    }
    // if (0 && import.meta.dev && ['按需要填写'].includes(sGameJoining)){
    //     console.log(`💥 ${sGameJoining} - 游戏接口未上线，临时关闭，弹出防止报错`); 
    //     return; // 此接口未发布，跳过以下内容 
    // }

    /**
     * 游戏的配置保存器 
     */
    const fnConfigSetter = (data) => {
        if (!data || data.error) {
            showNegativeNotify(data?.error); 
            console.error(`进入游戏載入时出错：下注基本值、歷史數據會失效`, sGameJoining, JSON.stringify(data));
            return;
        }
        // ↓ 保持这2个方法的顺序，方法2的数据需要依赖方法1先保存妥当它的数据
        let res = data;
        // 配置相同的游戏单独存储,避免相互污染
        if (sGameJoining === 'zhajinhuaGame') {
            const { config, ...rest } = res;
            res = { ...rest, [sGameJoining]: config };
        }
        console.log(1, res, sGameJoining);
        saveGameJoinState(res, sGameJoining, reconnect);
        if (oGameInfo.isGameWithHistoryTable){
            getHistoryAndSave(data.gameId, sGameJoining, reconnect);
        }
    }
    // ↓ 查询：游戏下注最大值等
    if (oGameInfo.isGameWithEntrance){
        // 说明 01：在这里单纯查配置信息，不要调用 EMIT_GAME_JOIN() 报告加入游戏
        // 要在后面待从入口页 “真正进入” 游戏 /indoor/id 页面后才在游戏内部调用 
        EMIT_GET_GAME_CONFIG({game: sApi}, fnConfigSetter); 
        // 说明 02: 另外“即使” 用户正在访问 /indoor/id 且可获得尾部厅 ID 时也不宜在此调用 EMIT_GAME_JOIN() 宣告进入游戏 
        // 而应在游戏内部调用，因为这类游戏在内部有切换厅的操作，如此设计更能可便于切换安排“退出” 和“进入” 的执行顺序 
    }else{
        // 大多数游戏通用查询方法 
        EMIT_GAME_JOIN(sApi, {}, fnConfigSetter);
    }
    // ↓ 查询：游戏历史 all, rare, high
    if (oGameInfo.isGameWithHistoryTable){
        EMIT_GETHISTORY_ON_JOIN(sApi, {}, saveGameHistoryOnJoin);
    }
    if (oGameInfo.isGameWithEntrance){
        return; // 这些游戏不必监听以下数据，因为无相关数据 
    }
    // ↓ 订阅：接收游戏实时的历史记录（用于追加到 all）
    stopReceivingGameHistoryObj = (()=>{
        if (sGameJoining === 'crashGame') { // 这游戏返回的数据不能用，不去订阅
            return ()=>null;
        }
        return ON_GAME_HISTORY_ON_HISTORY(sApi, (data) => {
            data &&= deepCopy(data); // 防止多处订阅互相污染数据
            if (1 && isDev) {
                console.log(`%c${sGameJoining} 游戏下注结果（实时）id: ${data._id}↓\n`, 'font-size:12px;color:red;', deepCopy(data));
            }
            handleHistoryUpdate(data, sGameJoining);
        });
    })();
    
    // 监听获取下一轮的 hash 和 jackpot 新值 
    // 在每局游戏结束时会收到数据 
    stopReceivingJackpotHash = ON_GAMES_INFO(sApi, (data) => {
        joinStateStore.setState(data);
    });
}

